import React from "react"
import { useFlashMessage, FlashMessageType } from "../common/flash-message-context"
import clsx from "clsx"

const FlashMessage: React.FC = () => {
  const { flashMessage, flashType, dismissFlashMessage } = useFlashMessage()
  if (!flashMessage) return null

  const colorSchemeTextMap = {
    [FlashMessageType.success]: "bg-blue-100 text-blue-900",
    [FlashMessageType.error]: "bg-red-100 text-red-900",
    [FlashMessageType.info]: "bg-gray-100 text-gray-900",
  }

  const colorSchemeButtonMap = {
    [FlashMessageType.success]: "bg-blue-400 text-white hover:bg-blue-600 focus:ring-blue-300",
    [FlashMessageType.error]: "bg-red-400 text-white hover:bg-red-600 focus:ring-red-300",
    [FlashMessageType.info]: "bg-gray-400 text-white hover:bg-gray-600 focus:ring-gray-300",
  }

  const colorSchemeText = colorSchemeTextMap[flashType]
  const colorSchemeButton = colorSchemeButtonMap[flashType]

  return (
    <div className={clsx(colorSchemeText, "flex items-center justify-center py-2")}>
      <span className="text-sm">{flashMessage}</span>
      <button
        className={clsx(
          colorSchemeButton,
          "ml-2 flex h-8 w-8 items-center justify-center rounded-full focus:outline-none focus:ring-2"
        )}
        onClick={dismissFlashMessage}
      >
        &times;
      </button>
    </div>
  )
}

export default FlashMessage
